import { useWebSocket, UUID } from "@gx1/gx-npm-lib";
import { AvatarComponent, PlainTooltipComponent, TypographyComponent } from "@gx1/gx-ui-common";
import { Fragment, ReactElement, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { WebSocketMessageEvent } from "../../../app.constants";
import styles from "./active-viewer-avatars.styles.module.scss";

type WsInMsgViewingInit = { event: WebSocketMessageEvent; initiativeId: UUID; userList: string[] };
const MAX_AVATARS_DISPLAYED = 3;

const ActiveViewerAvatarsComponent = () => {
  const { initiativeId = "" } = useParams<{ initiativeId: UUID }>();
  const [activeViewers, setActiveViewers] = useState<string[]>([]);
  const [additionalViewersTooltip, setAdditionalViewersTooltip] = useState<ReactElement[]>([]);
  const [wsMessage] = useWebSocket<WsInMsgViewingInit, unknown>();
  const additionalViewerCount = activeViewers.length - MAX_AVATARS_DISPLAYED;

  useEffect(() => {
    if (!wsMessage || !initiativeId || wsMessage.initiativeId !== initiativeId) {
      return;
    }
    if (wsMessage.event !== WebSocketMessageEvent.VIEWING_INITIATIVE || !Array.isArray(wsMessage.userList)) {
      return;
    }
    setActiveViewers([...wsMessage.userList.sort()]);
  }, [initiativeId, wsMessage]);

  useEffect(() => {
    const viewersNames: ReactElement[] = [];
    activeViewers.slice(MAX_AVATARS_DISPLAYED).forEach((viewer) => {
      viewersNames.push(<Fragment key={viewer}>{`${viewer} `}</Fragment>);
      viewersNames.push(<br key={`${viewer}-br`} />);
    });
    setAdditionalViewersTooltip(viewersNames);
  }, [activeViewers]);

  return (
    <div className={styles.root}>
      {activeViewers.slice(0, MAX_AVATARS_DISPLAYED).map((viewer) => {
        return (
          <PlainTooltipComponent
            key={viewer}
            additionalProps={{ placement: "bottom" }}
            isMasked={true}
            rootClassName={styles.avatar}
            title={viewer}
          >
            <AvatarComponent size="xs" text={viewer} />
          </PlainTooltipComponent>
        );
      })}
      {additionalViewerCount > 0 && (
        <PlainTooltipComponent additionalProps={{ placement: "bottom" }} rootClassName={styles.additionalAvatar} title={additionalViewersTooltip}>
          <TypographyComponent boldness="semi" element="span" styling="metadata-xs" rootClassName={styles.additionalViewersAvatar}>
            {`+${additionalViewerCount}`}
          </TypographyComponent>
        </PlainTooltipComponent>
      )}
    </div>
  );
};

export default ActiveViewerAvatarsComponent;
